import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Option } from '../../../../../../../ui-components/core-dropdown/core-dropdown.component';
import { CorePopupComponent } from '../../../../../../../ui-components/core-popup/core-popup.component';

@Component({
  selector: 'app-patient-phone-popup',
  templateUrl: './patient-phone-popup.component.html',
  styleUrl: './patient-phone-popup.component.scss',
})
export class PatientPhonePopupComponent {
  phoneTypes: Option[];
  patientPhones: any[];
  selectedPatientPhones: any[];
  @Output() saveOn = new EventEmitter();
  @ViewChild('corePopup') corePopup: CorePopupComponent;

  initilize(phoneTypes: Option[], patientPhones: any[], openDialog: boolean = true) {
    this.selectedPatientPhones = [];
    if (openDialog) {
      this.corePopup.openDialog();
    }
    this.phoneTypes = phoneTypes;
    this.patientPhones = patientPhones;
  }

  save() {
    this.saveOn.emit(this.selectedPatientPhones);
    this.corePopup.closeDialog();
  }

  initilizeAndSave(phoneTypes: Option[], patientPhones: any[]) {
    this.initilize(phoneTypes, patientPhones, false);
    this.selectedPatientPhones = [...this.patientPhones];
    this.saveOn.emit(this.selectedPatientPhones);
  }
}
